// limited prototype
// currently works only on top sticky elements

import React, { useState, useEffect, useRef, useTransition } from "react";

interface Props {
  children: React.ReactNode;
  className?: string;
  margin?: string;
  threshold?: number;
  callback?: (entry: IntersectionObserverEntry) => void;
}

const StickyElement: React.FC<Props> = ({
  children,
  className,
  margin,
  threshold = 1,
  callback,
}) => {
  const [isSticky, setIsSticky] = useState(false);
  const [_, startTransition] = useTransition();

  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        startTransition(() => {
          callback?.(entry);
          setIsSticky(entry.intersectionRatio <= threshold);
        });
      },
      {
        rootMargin: margin,
        root: null,
        threshold: [threshold, 0, 0.1, 0.5, 1],
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        observer.unobserve(ref.current);
      }
    };
  }, [callback]);

  return (
    <group
      ref={ref}
      className={`sticky ${isSticky ? className ?? "stuck" : ""}`}
      style={{
        width: "max-content",
        maxWidth: "max-Content",
        marginTop: "1px",
        // zIndex: 500,
        // background: "red",
      }}
    >
      {children}
    </group>
  );
};

export default StickyElement;
